<template>
  <MainLayout>
    <main class="dashboard">
      <DashboardTile
        v-for="(item, i) in tiles"
        :key="i"
        :item="item"
      />
      <div class="dashboard__apps">
        <div class="dashboard__apps-text">
          <h1>{{ $t('dashboard.apps.heading') }}</h1>
          <span v-html="$t('dashboard.apps.subheading')" />
        </div>
        <div class="dashboard__apps-buttons">
          <a :href="appStoreUrl">
            <button>
              <img src="@/assets/icons/app-store.svg" alt="download on the app store" />
            </button>
          </a>
          <a :href="googlePlayUrl">
            <button>
              <img src="@/assets/icons/google-play.svg" alt="get it on google play" />
            </button>
          </a>
        </div>
      </div>
    </main>
  </MainLayout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import subscriptionUpdateMixin from '@/common/mixins/subscription-update';
import DashboardTile from '@/components/DashboardTile';
import { MainLayout } from '@/components/layouts';
import { subscriptionActiveStatuses as activeStatuses } from '@/common/config';

import NewEstimateImg from '@/assets/images/new-estimate.svg';
import PastEstimatesImg from '@/assets/images/past-estimates.svg';
import SettingsImg from '@/assets/images/settings.svg';

const { mapState } = createNamespacedHelpers('user');

export default {
  name: 'DashboardView',
  components: { MainLayout, DashboardTile },
  mixins: [subscriptionUpdateMixin],
  data() {
    return {
      tiles: [
        {
          image: NewEstimateImg,
          name: 'new estimate',
          description: this.$t('dashboard.newEstimate.description'),
          buttonText: this.$t('dashboard.newEstimate.buttonText'),
          buttonLink: '/new-estimate',
        },
        {
          image: PastEstimatesImg,
          name: 'past estimates',
          description: this.$t('dashboard.pastEstimates.description'),
          buttonText: this.$t('dashboard.pastEstimates.buttonText'),
          buttonLink: '/past-estimates',
        },
        {
          image: SettingsImg,
          name: 'settings',
          description: this.$t('dashboard.settings.description'),
          buttonText: this.$t('dashboard.settings.buttonText'),
          buttonLink: '/settings',
        },
      ],
      appStoreUrl: process.env.VUE_APP_APPSTORE_URL,
      googlePlayUrl: process.env.VUE_APP_GOOGLEPLAY_URL,
    };
  },
  computed: {
    ...mapState({
      subscriptionActive: state => activeStatuses.includes(state.details.subscriptionStatus),
    }),
  },
  created() {
    if (!this.subscriptionActive) {
      this.$modals.info({
        header: this.$t('dashboard.subscriptionFailedModal.header'),
        content: this.$t('dashboard.subscriptionFailedModal.content'),
        buttonText: this.$t('dashboard.subscriptionFailedModal.button'),
        onButtonClick: this.updateSubscription,
        closable: false,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .dashboard {
    &__apps {
      align-items: center;
      background: $white;
      border-radius: 40px;
      box-shadow: 0 2px 83px 0 rgba(34, 48, 87, .07);
      display: flex;
      flex-direction: column;
      padding: 40px 20px;

      @include md-up {
        flex-direction: row;
        height: 180px;
        justify-content: space-between;
        padding: 20px 20px 20px 40px;
      }

      @include lg-up {
        padding: 20px 60px;
      }
    }

    &__apps-text {
      color: $primary;
      margin-bottom: 40px;
      max-width: 350px;
      text-align: center;

      @include md-up {
        margin: 0 40px 0 0;
        max-width: none;
        text-align: left;
      }

      h1 {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 16px;

        @include md-up {
          font-size: 24px;
        }
      }

      span {
        font-size: 16px;

        @include md-up {
          font-size: 18px;
        }
      }
    }

    &__apps-buttons {
      align-items: center;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;

      @include md-up {
        flex-direction: row;
      }

      button {
        @include center-content;
        background-color: $blueDark;
        border-radius: 12px;
        border: 0;
        cursor: pointer;
        height: 60px;
        width: 174px;
      }

      a {
        display: inline-block;

        &:first-child {
          margin-bottom: 20px;

          @include md-up {
            margin: 0 20px 0 0;
          }
        }
      }
    }
  }
</style>
